import { SEO_FIELDS_SLUG } from 'common/SeoFields/constants'

import type { DataSet } from './types'

import { initialSEOData } from 'common/SeoFields/interfaces'

export const initialDataSet: DataSet = {
  [SEO_FIELDS_SLUG]: initialSEOData,
}
